export default "__VITE_ASSET__GqSwyCsw__"